var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25794 2.24906C1.42478 1.97327 2.34165 0.970659 2.99639 1.00066C3.19218 1.01697 3.36532 1.13539 3.50585 1.27276C3.82848 1.58802 4.75218 2.77959 4.80481 3.03064C4.93218 3.64537 4.19902 4.0001 4.42376 4.6201C4.99534 6.01956 5.9806 7.00481 7.3806 7.57586C8.00008 7.80007 8.35483 7.06745 8.9701 7.19534C9.2201 7.24797 10.4127 8.17166 10.728 8.49429C10.8643 8.63429 10.9833 8.80796 10.9996 9.00375C11.0238 9.69269 9.95904 10.6227 9.75167 10.7416C9.26167 11.0922 8.62272 11.0858 7.84377 10.7237C5.6706 9.81954 2.19689 6.41167 1.27583 4.15643C0.923725 3.38169 0.89899 2.73853 1.25794 2.24906Z",
    stroke: "#FFFFFE",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ff3007f9c312c12e29d8d3bdd8bf95c4.svg";
export { ForwardRef as ReactComponent };